
import { IMRDXDashboardMultiController } from "./dxdashboard-multi.controller"
import { DXDASHBOARD_SERVICE_NAME } from "../../services"

import './dxdashboard-multi.scss'
import * as TEMPLATE from './dxdashboard-multi.tpl.html'

export const COMPONENT_NAME: string = 'imrDxdashboardMulti'

export class IMRDXDashboardMultiComponent implements ng.IComponentOptions {
    
    controller = [DXDASHBOARD_SERVICE_NAME, IMRDXDashboardMultiController]

    bindings = {
        options: '<'
    } as { [index: string]: string }

    template = TEMPLATE

}
